module.exports = __webpack_public_path__ + "static/media/Kiosk_Straight.7ef50ece.png";